<nav #toolbar id="landing-toolbar" fxLayout="row" fxLayoutAlign="center center" docScroll *ngIf="!adminRoutes">
  <div class="wrapper container" fxLayout="row" fxLayoutAlign="space-between center">
    <app-logo />

    <nav id="menus" class="d-flex justify-content-between w-100">
      <!-- <button
        id="packagesBtn"
        class="toolbar-menu-button"
        routerLink="/"
        color="primary"
        mat-button
      >
        <span class="menu-button-title">بسته‌ها</span>
      </button> -->
      <div class="d-flex align-items-center">
        <ul
          color="primary"
          class="toolbar-menu-button"
          color="primary"
          mat-button
        >
          <li class="submneu-services">
            <a color="primary" mat-button class="toolbar-menu-button">
              <span class="menu-button-title d-inline" mat-button>خدمات</span><jam-icon name="chevron-down" />
            </a>
            <ul class="submenus ul-submenu-services" id="services-menu">
              <li class="submenu-print">
                <a fxLayoutAlign="space-between center" color="primary" fxLayout="row">
                  <div class="w-100 d-flex justify-content-between">
                    <div>پرینت</div>
                    <jam-icon name="chevron-left" />
                  </div>
                </a>
                <ul class="submenus ul-submenu-level2">
                  <li>
                    <a routerLink="black-and-white-print" (click)="scroll()">
                      پرینت سیاه و سفید
                    </a>
                  </li>
                  <li>
                    <a routerLink="full-color-print" (click)="scroll()">
                      پرینت تمام رنگی
                    </a>
                  </li>
                  <li>
                    <a routerLink="half-color-print" (click)="scroll()">
                      پرینت نیمه رنگی
                    </a>
                  </li>
                  <li>
                    <a routerLink="combined-printing" (click)="scroll()">
                      پرینت ترکیبی
                    </a>
                  </li>
                </ul>
              </li>
              <li><a routerLink="thesis-binding">
                پرینت و صحافی پایان‌نامه
              </a></li>
              <li><a routerLink="thesis-editing">
                ویرایش پایان‌نامه
              </a></li>
            </ul>
          </li>
          <li>
            <a color="primary" mat-button class="toolbar-menu-button" routerLink="price-list">
              <span class="menu-button-title">قیمت خدمات</span>
            </a>
          </li>
          <li>
            <a color="primary" mat-button class="toolbar-menu-button">
              <span class="menu-button-title">بلاگ</span>
            </a>
          </li>
          <li>
            <a color="primary" mat-button class="toolbar-menu-button" routerLink="contact-us">
              <span class="menu-button-title">تماس با ما</span>
            </a>
          </li>
        </ul>          
      </div>
      <div class="d-flex align-items-center">
        <a color="primary" class="toolbar-menu-button" mat-button>
          <span class="menu-button-title">
            <mat-icon svgIcon="message-circle-chat" class="menu-gray" />
            پشتیبانی آنلاین
          </span>
        </a>

        <a
          color="primary"
          [routerLink]="['user', 'my-orders']"
          [queryParams]="{ index: 1 }"
          class="toolbar-menu-button"
          mat-button
        >
          <span class="menu-button-title">
            <mat-icon svgIcon="inbox-check" class="menu-gray" />
            پیگیری خرید
          </span>
        </a>

        <div
          id="icon-buttons"
          fxLayout="row"
          fxLayoutAlign="space-around center"
        >
          <a
            mat-button
            color="primary"
            name="user-notification"
            (click)="notificationDropdown.toggle()"
            *ngIf="isAuthenticated && user && !loading"
            id="userNotificationDropdownMenuBtn"
            [matBadge]="notSeenNotificationsLen$ | async"
            matBadgeSize="small"
            matBadgePosition="below before"
            matBadgeColor="warn"
            class="shopping-card-badge user-action-buttons"
          >
            <div fxLayout="row" fxLayoutAlign="center center">
              <mat-icon svgIcon="bell" class="menu-gray" />
            </div>
          </a>

          <app-dropdown #notificationDropdown>
            <app-notification-area
              [notifications]="(notifications$ | async)!"
            />
          </app-dropdown>

          <a
            mat-button
            color="primary"
            name="shopping-cart"
            (click)="cartDropdown.toggle()"
            *ngIf="isAuthenticated && user && !loading"
            id="userShoppingCartDropDownButton"
            [matBadge]="ordersCount"
            [matBadgeHidden]="ordersCount <= 0"
            matBadgeOverlap="false"
            matBadgePosition="before"
            matBadgeColor="accent"
            class="shopping-card-badge user-action-buttons"
          >
            <div fxLayout="row" fxLayoutAlign="center center">
              <mat-icon svgIcon="cart-shopping" class="blue" />
            </div>
          </a>

          <app-dropdown #cartDropdown>
            <shopping-cart-dropdown
              (click)="$event.stopPropagation()"
              [orders]="orders"
              [isAuthenticated]="isAuthenticated"
              (showBasket)="cartDropdown.isOpen = false"
              (closeShoppingCard)="cartDropdown.toggle()"
            />
          </app-dropdown>

          <a
            mat-button
            color="primary"
            *ngIf="isAuthenticated && user && !loading"
            (click)="toggleUserMenu()"
            class="user-indicator toolbar-menu-button user-action-buttons"
            type="button"
            id="userMenuTriggerButton"
          >
            <div fxLayout="row" fxLayoutAlign="center center">
              <img
                referrerpolicy="no-referrer"
                [src]="user.avatar?.url"
                *ngIf="user.avatar?.url"
                class="header-icon-only"
                priority="high"
              />
              <mat-icon
                svgIcon="circle-user"
                class="menu-gray"
                *ngIf="!user.avatar?.url"
              />
            </div>
          </a>

          <app-dropdown class="mat-user-menu" #userFloatingMenu>
            <app-landing-user-menu [user]="user" />
          </app-dropdown>

          <a
            mat-button
            color="primary"
            (click)="toggleUserMenu()"
            mat-stroked-button
            *ngIf="!isAuthenticated"
            class="border-0"
            type="button"
          >
            <img class="header-icon" src="assets/icons/login.svg" alt="" />
            <span class="font-size-15"> ورود </span>
          </a>
          <a
            class="burger-menu"
            (click)="showMenu = true"
          >
            <mat-icon svgIcon="menu" class="menu-gray" />
          </a>
        </div>
      </div>
    </nav>
  </div>
</nav>
<div class="mobile-menu" [ngClass]="{ show: showMenu }">
  <nav #toolbar class="d-flex flex-column">
    <div class="d-flex flex-column">
      <app-logo class="border-bottom py-3 px-2" />

      <div id="mobile-menus" class="d-flex flex-column w-100">
        <div
          *ngIf="isAuthenticated && user && !loading"
          class="d-flex flex-column py-4 border-bottom px-4"
        >
          <div
            class="d-flex justify-content-between align-items-center w-100 ps-sm-4 mb-5"
            routerLink="user"
            (click)="closeNavBar()"
          >
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <span class="user-name"> {{ user.fullName }}</span>
              <jam-icon [size]="30" name="chevron-left" />
            </div>
          </div>

          <div class="d-flex flex-column w-100 p-sm-4 p-2 blue-bg">
            <div
              class="d-flex align-items-center w-100 justify-content-between"
            >
              <div class="dflex align-items-baseline">
                <app-wallet-icon></app-wallet-icon>
                <span class="user-name text-white me-3">گردش کیف پول</span>
              </div>
              <jam-icon
                [size]="30"
                name="chevron-left"
                class="white-jam-icon"
              />
            </div>
            <span class="fs-5 text-white mt-4">
              موجودی : 100,000,000 ریال
            </span>
          </div>
          <div class="d-flex flex-column w-100 p-sm-4 p-2 mt-4 red-bg">
            <div
              class="d-flex align-items-center w-100 justify-content-between"
            >
              <div class="dflex align-items-baseline">
                <app-dollar-icon />
                <span class="user-name text-white me-3">گردش امتیازات</span>
              </div>
              <jam-icon
                [size]="30"
                name="chevron-left"
                class="white-jam-icon"
              ></jam-icon>
            </div>
            <span class="fs-5 text-white mt-4">
              تعداد امتیازات : ۲۵۶ ستاره
            </span>
          </div>
        </div>
        <div class="d-flex flex-column pt-4">
          <!-- <button
            color="primary"
            [routerLink]="['user', 'my-orders']"
            [queryParams]="{ index: 1 }"
            class="toolbar-menu-button menu-title w-100 d-flex justify-content-between align-items-center px-4 pb-4"
            mat-button
            style="margin-top: 1rem;"
          >
            <span class="menu-button-title">
              <span>
                <app-tracking-icon> </app-tracking-icon>
                <span class="me-2"> پیگیری سفارش</span>
              </span>
            </span>
          </button> -->
          <div
            fxLayout="row"
            fxLayoutAlign="space-around center"
            class="icon-buttons w-100"
          >
            <a
              (click)="toggleUserMenu()"
              mat-stroked-button
              *ngIf="isAuthenticated && user && !loading"
              class="border-0 w-100 justify-content-start"
              [routerLink]="['user', 'my-orders']"
              [queryParams]="{ index: 1 }"
            >
              <app-tracking-icon style="margin: 0.5rem" />
              <span class="font-size-15 text-blue">پیگیری سفارش</span>
            </a>
          </div>

          <div class="accordion" id="accordionExample">
            <div class="">
              <h2 class="accordion-header" id="headingOne">
                <a
                  (click)="
                    selectedMenuTitle =
                      selectedMenuTitle == mobileMenuTitles.print
                        ? null
                        : mobileMenuTitles.print
                  "
                  class="accordion-button menu-title w-100 d-flex justify-content-between align-items-center px-4 pb-4"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#printCollapse"
                  aria-expanded="false"
                  aria-controls="printCollapse"
                >
                  <span>
                    <app-print-icon
                      [fillColor]="
                        selectedMenuTitle == mobileMenuTitles.print
                          ? '#E5364B'
                          : '#2860BE'
                      "
                    />
                    <span class="me-2"> خدمات پرینت </span>
                  </span>
                  <jam-icon [size]="30" name="chevron-left" />
                </a>
              </h2>
              <div
                id="printCollapse"
                class="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div class="d-flex flex-column collapse-bg px-4">
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="black-and-white-print"
                    class="border-bottom"
                  >
                    پرینت سیاه و سفید
                  </a>
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="full-color-print"
                    class="border-bottom"
                  >
                    پرینت رنگی
                  </a>
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="half-color-print"
                    class="border-bottom"
                  >
                    پرینت نیمه رنگی
                  </a>
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="combined-printing"
                    class="border-bottom"
                  >
                    پرینت ترکیبی
                  </a>
                </div>
              </div>
            </div>
            <div class="">
              <h2 class="accordion-header" id="headingTwo">
                <a
                  (click)="
                    selectedMenuTitle =
                      selectedMenuTitle == mobileMenuTitles.thesis
                        ? null
                        : mobileMenuTitles.thesis
                  "
                  class="accordion-button menu-title w-100 d-flex justify-content-between align-items-center px-4 pb-4"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#thesisCollapse"
                  aria-expanded="false"
                  aria-controls="thesisCollapse"
                >
                  <span>
                    <app-thesis-icon
                      [fillColor]="
                        selectedMenuTitle == mobileMenuTitles.thesis
                          ? '#E5364B'
                          : '#2860BE'
                      "
                    />
                    <span class="me-2"> خدمات پایان‌نامه</span>
                  </span>
                  <jam-icon [size]="30" name="chevron-left" />
                </a>
              </h2>
              <div
                id="thesisCollapse"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div class="d-flex flex-column collapse-bg px-4">
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="thesis-binding"
                    class="border-bottom"
                  >
                    پایان‌نامه
                  </a>
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="thesis-editing"
                    class="border-bottom"
                  >
                    ویرایش پایان‌نامه
                  </a>
                </div>
              </div>
            </div>
            <div class="">
              <h2 class="accordion-header" id="headingThree">
                <a
                  (click)="
                    selectedMenuTitle =
                      selectedMenuTitle == mobileMenuTitles.support
                        ? null
                        : mobileMenuTitles.support
                  "
                  class="accordion-button menu-title w-100 d-flex justify-content-between align-items-center px-4 pb-4"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#supportCollapse"
                  aria-expanded="false"
                  aria-controls="supportCollapse"
                >
                  <span>
                    <app-support-icon
                      [fillColor]="
                        selectedMenuTitle == mobileMenuTitles.support
                          ? '#E5364B'
                          : '#2860BE'
                      "
                    />
                    <span class="me-2"> راهنمایی و پشتیبانی</span>
                  </span>
                  <jam-icon [size]="30" name="chevron-left" />
                </a>
              </h2>
              <div
                id="supportCollapse"
                class="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div class="d-flex flex-column collapse-bg px-4">
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="contact-us"
                    class="border-bottom"
                  >
                    تماس با ما
                  </a>
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="faq"
                    class="border-bottom"
                  >
                    پرسش های متداول
                  </a>
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="faq"
                    class="border-bottom"
                  >
                    شرایط و مقررات
                  </a>
                  <a
                    (click)="closeNavBar()"
                    mat-menu-item
                    routerLink="about-us"
                    class="border-bottom"
                  >
                    درباره زیراکسی
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            fxLayout="row"
            fxLayoutAlign="space-around center"
            class="icon-buttons w-100"
          >
          <a
            (click)="closeNavBar()"
            mat-stroked-button
            class="border-0 w-100 justify-content-start"
            [routerLink]="'price-list'"
          >
              <mat-icon class="blue margin-left-half" svgIcon="money-check-dollar" style="width: 32px; height: 32px; margin-right: 0;" />
              <span class="font-size-15 text-blue">قیمت خدمات</span>
            </a>
          </div>

          <div
            fxLayout="row"
            fxLayoutAlign="space-around center"
            class="icon-buttons w-100"
          >
            <a
              (click)="toggleUserMenu()"
              mat-stroked-button
              *ngIf="isAuthenticated && user && !loading"
              class="border-0 w-100 justify-content-start"
              routerLink="about-us"
            >
              <app-ziraxi-mag-icon style="margin: 0 0.25rem 0 0.75rem" />
              <span class="font-size-15 text-blue">زیراکسی مگ</span>
            </a>
          </div>
        </div>
        <div class="d-flex">
          <div
            fxLayout="row"
            fxLayoutAlign="space-around center"
            class="icon-buttons w-100"
          >
            <a
              (click)="toggleUserMenu(); closeNavBar()"
              mat-stroked-button
              *ngIf="!isAuthenticated && !loading"
              class="border-0 w-100 justify-content-start"
            >
              <span class="font-size-15 text-blue d-flex align-items-center">
                <mat-icon
                  class="blue margin-left-half"
                  svgIcon="arrow-right-to-bracket"
                />
                <span>ورود</span></span
              >
            </a>
            <a
              (click)="logoutUser()"
              mat-stroked-button
              *ngIf="isAuthenticated && user && !loading"
              class="border-0 w-100 justify-content-start"
            >
              <span class="font-size-15 text-blue d-flex align-items-center">
                <mat-icon
                  class="warn margin-left-half"
                  svgIcon="arrow-right-from-bracket"
                />
                <span>خروج</span></span
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
<div class="cover" *ngIf="showMenu" (click)="closeNavBar()"></div>
